import styled from "styled-components";

import theme from "config/theme";

export const Inner = styled.div`
  width: 100%;
  display: flex !important;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  outline: none;

  @media (max-width: ${theme.size.mobile}) {
    margin-top: 0;
  }
`;
